import i18n from 'i18nextInstance';

const KEY_MAP = {
    asthma: i18n.t('Asma'),
    bad: i18n.t('Mala'),
    cholesterol: i18n.t('Colesterol'),
    colon_exam: i18n.t('Revisión de colon/recto'),
    copd: i18n.t('EPOC'),
    diabetes: i18n.t('Diabetes'),
    dont_have_access: i18n.t('Sin acceso a servicios'),
    dont_have_time: i18n.t('No tiene tiempo'),
    drink_everyday: i18n.t('Diariamente'),
    drink_never: i18n.t('Nunca'),
    drink_special_ocassions: i18n.t('Ocasionalmente'),
    drink_twice_a_week: i18n.t('1 o 2 veces por semana'),
    feel_stress_everyday: i18n.t('Diario'),
    feel_stress_few_time: i18n.t('Pocas veces'),
    feel_stress_never: i18n.t('Nunca'),
    feel_stress_weekly: i18n.t('Varias veces por semana'),
    good: i18n.t('Buena'),
    gynecological_control: i18n.t('Control ginecológico anual'),
    health_insurance_problems: i18n.t('Prob. con obra social'),
    hypertension: i18n.t('Hipertensión'),
    last_year: i18n.t('En el último año'),
    mammography_or_breast_control: i18n.t('Mamografía o examen físico'),
    more_than_one_year: i18n.t('Más de un año'),
    more_than_two_years: i18n.t('Más de dos años'),
    never: i18n.t('Nunca'),
    normal_weight: i18n.t('Normal'),
    not_necessary: i18n.t('No lo ve necesario'),
    obesity_1: i18n.t('Obesidad I'),
    obesity_2: i18n.t('Obesidad II'),
    obesity_3: i18n.t('Obesidad III'),
    other_chronic_disease: i18n.t('Otra'),
    other_reason: i18n.t('Otro motivo'),
    overweight: i18n.t('Sobrepeso'),
    pending_exams: i18n.t('Lo tiene pendiente'),
    regular: i18n.t('Regular'),
    smoke_everyday: i18n.t('Todos los días'),
    smoke_in_the_past: i18n.t('En el pasado'),
    smoke_never: i18n.t('Nunca'),
    smoke_some_days: i18n.t('Ocasionalmente'),
    underweight: i18n.t('Bajo peso'),
    urologist_control: i18n.t('Control urológico'),
    very_good: i18n.t('Muy buena')
		
};

export const parseKey = key => KEY_MAP[key] ?? '-';
